import {
  BASE_API_FORM_TYPE_STRING, BASE_API_FORM_TYPE_DATE,
} from './api-constants';
import BaseApi from './base-api';

class SampleCrudApi extends BaseApi {
  constructor(args) {
    super(args);
    this.url += '/crud';
  }

  // eslint-disable-next-line
  getFiltered(page, rowsPerPage, orderBy, orderDirection) {
    // return this.get(`all?pageSize=${rowsPerPage}&page=${page}&orderBy=${orderBy}&orderDirection=${orderDirection}`);
    const p = new Promise((resolve, reject) => {
      setTimeout(() => {
        // reject(new Error('Data not found'));
        resolve({
          data: {
            data: {
              payload: [
                {
                  _id: '1',
                  avatar: 'https://api.adorable.io/avatars/285/abott@adorable.png',
                  thumbnail: 'http://picsum.photos/100/100',
                  text: 'Andi',
                  number: 10,
                  currency: 100,
                  dateMonth: new Date(2020, 3, 1),
                  date: new Date(2020, 3, 1),
                  custom: '1',
                },
                {
                  _id: '2',
                  avatar: 'https://api.adorable.io/avatars/285/budi@adorable.png',
                  thumbnail: 'http://picsum.photos/100/100',
                  text: 'Budi',
                  number: 1000,
                  currency: 100000,
                  dateMonth: new Date(2020, 4, 1),
                  date: new Date(2020, 4, 1),
                  custom: '2',
                },
              ],
              success: true,
            },
            recordsTotal: 2,
            recorsTotalExist: true,
          },
        });
      }, 1000);
    });
    return p;
  }

  // eslint-disable-next-line no-unused-vars
  getById(id) {
    return this.get(`detail/${id}`);
  }

  create(formData) {
    const rawData = formData;
    const data = this.prepareData(this.prepareRawData(rawData), 'form-data');
    return this.post('', data,
      {
        headers: {
          'content-type': 'multipart/form-data',
        },
      });
  }

  updateById(id, formData) {
    const rawData = formData;
    const data = this.prepareData(this.prepareRawData(rawData), 'form-data');
    return this.put(id, data,
      {
        headers: {
          'content-type': 'multipart/form-data',
        },
      });
  }

  deleteById(id) {
    return this.delete(`${id}`);
  }

  // eslint-disable-next-line class-methods-use-this
  prepareRawData(data) {
    return [
      {
        type: BASE_API_FORM_TYPE_STRING,
        name: 'title',
        value: data.title,
      },
      {
        type: BASE_API_FORM_TYPE_DATE,
        name: 'publishedAt',
        value: data.publishedAt,
      },
      {
        type: BASE_API_FORM_TYPE_STRING,
        name: 'picture',
        value: data.picture,
      },
    ];
  }
}

export default SampleCrudApi;
